import { createSlice } from "@reduxjs/toolkit";

export interface IUser{
	info:{
		username:string;
		isLogin:boolean;
	}
}

const initialState: IUser={
	info:{
		username:'',
		isLogin:false
	}
}

export const user = createSlice({
	name:'user',
	initialState,
	reducers:{
		getinfo:(state:IUser,actions)=>{
			state.info = actions.payload
		}
	}
})

export const { getinfo } = user.actions

export default user.reducer